class PaddleProvider {
  subscribers: PaddleProviderSubscriber[];
  enableDebug: boolean;

  log(...messages: any[]) {
    if (this.enableDebug) {
      console.log('PaddleProvider', ...messages);
    }
  }

  constructor() {
    this.enableDebug = true;
    Paddle?.Setup?.({
      vendor: 37611,
      eventCallback: (data) => {
        this.log(
          'Paddle eventCallback before',
          data,
          'subscribers',
          this.subscribers.map((s) => s.subscriberId)
        );

        this.subscribers = this.subscribers.filter((subscriber) => {
          let result = subscriber.onEvent(data);
          this.log(
            `Subscriber ${subscriber.subscriberId} for event`,
            data,
            `result`,
            result
          );

          return result === 'keep';
        });

        this.log(
          'Paddle eventCallback after',
          'subscribers',
          this.subscribers.map((s) => s.subscriberId)
        );
      },
    });
    this.subscribers = [];
  }

  checkoutOpen(props: CheckoutOpenProps, callback?: PaddleProviderSubscriber) {
    if (callback) {
      this.log('Subscribing', callback.subscriberId);
      // remove listener with the same callbackId
      this.subscribers = this.subscribers.filter((listener) => {
        return listener.subscriberId !== callback.subscriberId;
      });
      this.subscribers.push(callback);
    }
    Paddle.Checkout.open({
      override: props.override,
    });
  }

  unsubscribe = (callbackId: string) => {
    this.log('Unsubscribing', callbackId);
    this.subscribers = this.subscribers.filter((listener) => {
      return listener.subscriberId !== callbackId;
    });
  };
}

export interface CheckoutOpenProps {
  override?: string;
}

export interface PaddleProviderSubscriber {
  subscriberId: string;
  onEvent: (data: PaddleEventType) => PaddleProviderListenerResult;
}

export interface PaddleEventType {
  event: string;
  [key: string]: any;
}

export type PaddleProviderListenerResult = 'remove' | 'keep';

export const PaddleProviderInstance = new PaddleProvider();
